import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";

export default function DeleteWarningModal({ open, setOpen, onDelete }) {
  const onClose = () => {
    setOpen(false);
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content>
        <Section style={{ backgroundColor: "white" }}>
          <Title className="is-centered">Are you sure?</Title>
          <Columns isMultiline>
            <Column>
              <p className="is-centered">
                Deleting this item is irreversible, and any data associated with
                this item will also be deleted
              </p>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Button
                color="info"
                onClick={() => {
                  setOpen(false);
                }}
                isFullWidth
              >
                Cancel
              </Button>
            </Column>
            <Column>
              <Button color="danger" onClick={onDelete} isFullWidth>
                Delete
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
